<template>
	<div>
		<div v-if="data5.length">
			<Tree :data="data5" :render="renderContent"></Tree>
		</div>

		<div class="btn_newsort" v-else @click="Creatfirstroot">新建根类</div>

		<VsModal v-model="modelshow" top="200" width="800px" footerhide>
			<div slot="header">
				<span>新建分类</span>
			</div>
			<div slot="content" style="width: 100%;display: flex;justify-content: center;">
				<Vsform ref="resetform" @fun="ActionFun" :formdata="formdata"></Vsform>
			</div>
		</VsModal>
	</div>
</template>
<script>
	import infoAdd from './TheAddUserinfo.vue'
	export default {
		props: {
			data: {},
			shehename: {},
			infoNum: Number,
			chr: Boolean,
		},
		computed: {
			mingcheng() {
				return this.shenhename
			},
			mdata() {
				return this.data
			},
		},
		watch: {
			data(newO) {
				this.data5 = newO
			}
		},
		mounted() {
			this.fnGetinfoSort()
		},
		data() {
			return {
				select: {
					data: '',
					node: '',
					root: ''
				},
				selectNodeKey: '-1', //选中文件夹效果
				modelfull: false,
				modelshow: false,
				infoRoot: '', //创建临时类别标记
				formdata: { //审核form组件配置
					formwidth: '300',
					action: 'fun', //父组件事件
					lable: {
						show: true,
						width: '80',
						color: '',
						fontsize: '',
						backcolor: '',
					},
					sumitbtn: {
						show: true,
						desc: '确定',
						btntype: 'success',
						width: '',
						height: '',
						margin: '10px 0px 15px 100px',
						backcolor: '#00cc99',
						color: '#fff',
						fontsize: '14px'
					},
					resetbtn: {
						show: false,
						desc: '取消',
						btntype: 'success',
						width: '80',
						height: '',
						margin: '10px 10px 0px 0',
						backcolor: '#00cc99',
						color: '#fff',
						fontsize: '14px'
					},

					list: [{
							lable: '类别名称',
							key: 'KHMC',
							value: '',
							max: '20',
							width: '300',
							require: 'true',
							type: 'text',
							clearable: 'clearable',
							placeholder: '类别名称',
						},

					],

				},
				data5: [],
				iconprops: {
					type: 'default',
					size: '18',
				},

			}
		},

		methods: {
			fnviewTree(arr) {
				let d = arr.map(v => {
					if (v.children) {
						return {
							'name': v.Category,
							CategoryID: v.CategoryID,
							Level: v.Level,
							expand: false,
							'children': this.fnviewTree(v.children)
						}
					} else {
						return {
							'name': v.Category,
							CategoryID: v.CategoryID,
							Level: v.Level,
							expand: false,
						}
					}
				})
				return d
			},

			fnGetinfoSort() {
				let params = this.$fun.GetUserConstant()
				//查询客户类别列表  ErpGetKHInfoRoot
				this.$Api.ErpGetKHInfoRoot(params).then((res) => {
					console.log(params)
					console.log(res)
					if (!res.data) {
						this.Creatfirstroot()
						this.fnGetinfoSort()
						return
					}
					res.data.Category = '客户档案'
					this.data5 = this.fnviewTree([res.data])
				})
			},

			Creatfirstroot() {
				let params = {}
				params.KHMC = '客户档案'
				this.ActionFun(params)
			},
			fnInfosortChange(data, node, root) { //新建分类时储存临时信息
				console.log(data)
				this.select.data = data
				this.select.node = node
				this.select.root = root
				this.modelshow = true
				this.infoRoot = data.CategoryID
			},

			ActionFun(data) { //新建商品类别，form组件返回动作，data是返回数据
				//console.log(this.data5[0].children[0])
				//console.log(data)
				let params = Object.assign({}, data, this.$fun.GetUserConstant())
				params.ROOT = this.infoRoot //根目录可为空，子目录必填
				//params.KHMC=''///类别名称
				console.log(params)
				var str = params.KHMC.replace(/(^\s*)|(\s*$)/g, '')
				if (str == null || str == '') {
					this.$XModal.alert('类别名称不能为空！')
					return
				}
				this.$Api.ErpAddKHInfoSort(params).then((res) => {
					console.log(res)
					//console.log(9999999)
					if (res.status == 'SUCCESS') {
						this.$Message.success({
							content: '添加成功',
							druation: 3,
							background: true
						})
						this.fnGetinfoSort() //再次请求
						this.$refs.resetform.Resetdata()

						//this.modelshow=false
						this.$emit('on-reset')
					} else {
						this.$Message.error(res.msg)
					}
					///调用父组件更新数据
				})

			},
			Selected(data) { //选择类别
				this.infoRoot = data.CategoryID //储存商品父类id
				this.selectNodeKey = data.nodeKey
				console.log(data)
				this.$emit('on-select', data)
			},
			fnInfoSortDelete(data, node, root) { //删除类别
				console.log(data)
				this.$Modal.confirm({
					title: '确定删除此分类吗？',
					onOk: () => {
						let params = this.$fun.GetUserConstant()
						params.InfoID = data.CategoryID
						console.log(params)
						this.$Api.ErpKHinfoSortdelete(params).then((res) => {
							console.log(res)
							if (res.status == 'SUCCESS') {
								//this.fnGetinfoSort()//再次请求
								this.remove(data, node, root)
								this.$Message.success(res.msg)
							} else {
								this.$Message.error(res.msg)
							}
						})

					}
				})

			},
			fnAddinfoAct() { //提交客户信息
				this.$emit('on-refresh')
			},

			renderContent(h, {
				root,
				node,
				data
			}) {
				return h('div', {
					class: {
						itembox: true
					},
					style: {
						// background:this.selectNodeKey==data.nodeKey?'#80ffff':''
					},

				}, [

					h('div', {
							class: {
								itemwrap: true
							},


						},
						[


							h('li', {
									style: {
										height: '100%',
										color: '#fff',

										//background:'#505050',
										display: 'flex',
										'align-items': 'center'
									},
									on: {
										'click': e => {
											e.stopPropagation()
											this.Selected(data, root, node)
										},
										'dblclick': e => {
											e.stopPropagation()
											this.show(data, root, node)
										}
									}

								}, [
									h('div', {},


										[
											h('IconSvg', {
												props: {
													name: 'iconicon_folder',
													size: 16,
												},
												style: {
													color: '#fb7e36',

												},
												on: {
													click: e => {
														e.stopPropagation()

														this.show(data, root, node)
													}
												}
											}),
										]



									),
									h('div', {
										style: {
											// color:'#666666',
											color: this.selectNodeKey == data.nodeKey ? '#2d8cf0' : '',
											//background:'#505050',
											'margin-left': '5px',
											//'font-size':''
										},


									}, data.name)
								]

							),
							h('div', {
									style: {
										//height:'26px',
										//color:'#666666',
										//position:'absolute',
										right: '2px',
										//top:'-5px',
										'margin-left': '5px',
										display: this.selectNodeKey == data.nodeKey ? 'flex' : 'none',
										//background:'#202020',
										'align-items': 'center'
									}
								},
								[
									h('li', {
											style: {
												// display:data.Level === 1&&this.infoNum>0?'':'none',
												display: data.Level === 1 ? '' : 'none',
											},
											on: {
												click: e => {
													e.stopPropagation()
													this.fnInfosortChange(data, node, root)
												}
											}
										},
										[
											h('Tooltip', {
												props: {
													content: '新建客户分类'
												}
											}, [
												h('IconSvg', {
													props: {
														name: 'iconjia',
														size: 14,
														color: '#515151'
													},

												})
											])
										]),
									h('li', {}, [
										h('Tooltip', {
											props: {
												content: '添加客户信息'
											}
										}, [
											h(infoAdd, {
												props: {
													category: data
												},
												on: {
													'on-confirm': data => {
														//console.log(data)
														this.fnAddinfoAct(data) //提交客户信息
													}
												},
												style: {
													//color:'red',
													display: data.Level === 1 ? 'none' : 'flex'
												},
											}, [
												h('IconSvg', {
													slot: 'title',
													props: {
														name: 'iconjia1',
														size: 13,
														color: '#fb7e36'
													}
												}, [

												])
											])
										]),
									]),

									h('li', {
											on: {
												click: e => {
													e.stopPropagation()
													this.fnInfoSortDelete(data, node, root)
												}
											}
										},
										[
											h('Tooltip', {
												props: {
													content: '删除客户分类'
												}
											}, [
												h('IconSvg', {
													props: {
														name: 'iconlajitong',
														size: 16,
														color: '#515151',
														left: 20,
													},
													style: {
														//color:'red',
														display: data.Level === 1 ? 'none' : 'flex'
													},
												})
											])
										]),
								]


							)


						])
				]);
			},
			show(data) {
				console.log(data)
				data.expand = !data.expand
				//console.log(data)
			},


			// append(data) {
			// 	console.log(999)
			// 	const children = data.children || [];
			// 	children.push({
			// 		KHMC: 'appended node',
			// 		expand: true
			// 	});
			// 	data.expand=true
			// 	this.$set(data, 'children', children);
			// },
			appenddata(data) {
				console.log(this.select.root)
				console.log(this.select.node)
				// const parentKey =this.select.root.map(el => el === this.select.node).parent;
				// const parent = this.select.root.find(el => el.nodeKey === parentKey);
				this.select.root.map(v => {
					if (v == this.select.node) {
						console.log(v)
					}
				})

				//const index = parent.children.indexOf(this.select.data);
				console.log(parentKey)
				console.log(parent)
				const children = parent.children || [];
				children.push(data);
			},
			remove(data, node, root) {
				const parentKey = root.find(el => el === node).parent;
				const parent = root.find(el => el.nodeKey === parentKey).node;
				const index = parent.children.indexOf(data);
				parent.children.splice(index, 1);
			}
		}
	}
</script>
<style lang="less">
	.itembox {
		//width: 100%;
		padding-right: 5px;
		//max-width: 130px;
		height: 26px;
		//	padding: 5px;

		// border: 1px solid #C0C0C0;

		border-radius: 3px;
		display: inline-block;
		//background: red;
		cursor: pointer;
		user-select: none;


	}

	.itemwrap {
		width: 100%;
		height: 100%;
		display: flex;
		position: relative;
		align-items: center;
		justify-content: space-between;
		//background: #17233D;
		//color: #fff;
		// font-size: ;

		// li{
		// 	//background: #1890FF
		// }
	}

	.itemwrap>li>div {
		color: #000;
	}

	.ivu-modal-header {
		background: #17233D;
	}

	.ivu-input {
		display: inline-block;
		width: 100%;
		height: 32px;
		//line-height: 1.5;
		padding: 4px 7px;
		font-size: 14px;
		font-weight: 600;
		border: 1px solid #dcdee2;
		border-radius: 4px;
		color: #303030;
		background-color: #fff;
		background-image: none;
		position: relative;
		cursor: text;
		transition: border .2s ease-in-out, background .2s ease-in-out, box-shadow .2s ease-in-out;
	}

	.ivu-tree-arrow {
		//background: #1890FF;
		//	position:absolute;
		//top: 20px;
	}

	.ivu-tree-arrow .ivu-tree-arrow-open {}

	.btn_newsort {
		width: 90px;
		height: 25px;
		margin: 10px 0 0 15px;
		//border: 1px solid #757575;
		//font-size: 16px;
		//color: #fff;
		background: #CCC;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 5px;
		cursor: pointer;

	}
</style>
